import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	allSuggestionsLabelPrefixNonFinal: {
		id: 'periscope.suggestions.filter.all-suggestions-label-prefix-non-final',
		defaultMessage: 'Suggestion type',
		description:
			'This is the text label for work suggestions. This is prefix for the dropdown label',
	},
});
